import * as React from "react";
const SvgMerge = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "-2 -2 22 22", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, d: "M17.25 6V2.957A2.207 2.207 0 0 0 15.041.75H2.957A2.207 2.207 0 0 0 .75 2.957V6m0 6v3.043c0 1.219.988 2.207 2.207 2.207h12.085a2.207 2.207 0 0 0 2.207-2.207V12" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, d: "m6 4.5 3 3 3-3m0 9-3-3-3 3" }));
export {
  SvgMerge as default
};
//# sourceMappingURL=merge.js.map
